import React from 'react';
import FormPrefSelector from './form_pref_selector';
import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';
import SectionYoutube from './section_youtube';
import moment from 'moment';
import axios from '../axios';

moment.locale('ja');

const SectionDetail = ({
  props,
  event,
  setEvent,
  contents,
  setContents,
  dateAlert,
  eventDateError,
  isDateChangeProhibitionDisplay,
  isEventEndDatetimeTouched,
  isApplicationDueDateTouched,
  isMeetingDatetimeTouched,
  handleEventDateInput,
  isNewPolicyApplicable,
}) => {
  const modalRef = React.useRef();
  const [cancelPolicyText, setCancelPolicyText] = React.useState('');

  React.useEffect(() => {
    axios
      .post('/api/event/calcel_policy_text', { params: { event } })
      .then((response) => setCancelPolicyText(response.data.cancel_policy));
  }, [event]);

  return (
    <section id="details">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          その他
        </p>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <ModalContentBaseXl
            ref={modalRef}
            previewContent={
              <div className="d-flex justify-content-between align-items-center">
                <p className="cp-0 m-0 text-black-333 text-left bg-white border-0">
                  詳細設定する
                </p>
                <div style={{ width: 12 }} className="text-black-333">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                  </svg>
                </div>
              </div>
            }
            modalContent={
              <ModalContentForDetail
                props={props}
                event={event}
                setEvent={setEvent}
                contents={contents}
                setContents={setContents}
                closeModal={() => modalRef.current.closeModal()}
                dateAlert={dateAlert}
                eventDateError={eventDateError}
                isDateChangeProhibitionDisplay={isDateChangeProhibitionDisplay}
                isEventEndDatetimeTouched={isEventEndDatetimeTouched}
                isApplicationDueDateTouched={isApplicationDueDateTouched}
                isMeetingDatetimeTouched={isMeetingDatetimeTouched}
                handleEventDateInput={handleEventDateInput}
                isNewPolicyApplicable={isNewPolicyApplicable}
              />
            }
          />
          <hr />
          <div className="text-gray text-fz-small">
            <div className="mb-2">
              YouTube：{' '}
              {contents
                .filter((content) => content.content_type === 4)
                .sort((a, b) => a.sort_order - b.sort_order)
                .map((c) => `https://youtu.be/${c.body}`)
                .toString()}
            </div>
            <div className="mb-2">
              リアル／オンライン： {event.is_online ? 'オンライン' : 'リアル'}
            </div>
            <div className="mb-2">
              開催場所
              <div className="ml-2">
                目安：{' '}
                {props.countriesPrefs.find((p) => p.id === event.pref_id)
                  ?.name || '未設定'}
                <br />
                目安・場所など： {event.place || '未設定'}
                <br />
                詳細： {event.place_detail || '未設定'}
                <br />
                参加者にしか表示しない：{' '}
                {!event.is_display_place_detail ? 'はい' : 'いいえ'}
              </div>
            </div>
            <div className="mb-2">
              集合場所
              <div className="ml-2">
                目安：{' '}
                {props.countriesPrefs.find(
                  (p) => p.id === event.meeting_pref_id,
                )?.name || '未設定'}
                <br />
                目安・場所など： {event.meeting_place || '未設定'}
                <br />
                詳細： {event.meeting_place_detail || '未設定'}
                <br />
                参加者にしか表示しない：{' '}
                {!event.is_display_meeting_place_detail ? 'はい' : 'いいえ'}
              </div>
            </div>
            <div className="mb-2">
              イベント参加人数
              <div className="ml-2">
                最小： {event.min_num_of_people || '未設定'}
                <br />
                最大： {event.max_num_of_people || '未設定'}
              </div>
            </div>
            <div className="mb-2">
              イベント日時
              <div className="ml-2">
                集合：{' '}
                {event.meeting_datetime
                  ? moment(event.meeting_datetime).format('lll')
                  : '未設定'}
                <br />
                申込締切：{' '}
                {event.application_due_date
                  ? moment(event.application_due_date).format('lll')
                  : '未設定'}
              </div>
            </div>
            <div className="mb-2">
              サークルメンバー以外に表示:{' '}
              {event.is_publicity ? '公開' : 'メンバー限定'}
            </div>
            <div className="mb-2">
              募集中ステータス：{' '}
              {event.is_application_allowed ? '募集中' : '募集停止'}
            </div>
            <div className="mb-2">
              キャンセルポリシー
              <div className="ml-2" style={{ whiteSpace: 'pre-line' }}>
                {cancelPolicyText}
              </div>
            </div>
            <div className="mb-2">
              自動送信テキスト：{event.autoresponse_message || '未設定'}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ModalContentForDetail = ({
  props,
  event,
  setEvent,
  contents,
  setContents,
  closeModal,
  dateAlert,
  eventDateError,
  isDateChangeProhibitionDisplay,
  isEventEndDatetimeTouched,
  isApplicationDueDateTouched,
  isMeetingDatetimeTouched,
  handleEventDateInput,
  isNewPolicyApplicable,
}) => {
  return (
    <div className="card bg-gray" style={{ paddingBottom: '144px' }}>
      <div
        className="bg-white w-100 border-bottom"
        style={{
          zIndex: 9998,
          borderRadius: '16px 16px 0 0',
          position: 'fixed',
        }}
      >
        <button
          type="button"
          className="close close__modal position--modalclose"
          aria-label="Close"
          onClick={() => closeModal()}
        >
          <span className="text-fz-24px float-right m-2" aria-hidden="true">
            ×
          </span>
        </button>
      </div>
      <SectionYoutube
        eventId={event.id}
        youtubeContents={
          contents
            .filter((content) => content.content_type === 4)
            .sort((a, b) => a.sort_order - b.sort_order) || []
        }
        setContents={setContents}
      />
      <div className="bg-gray h-100 pt-5 pb-5">
        <SectionOnline event={event} setEvent={setEvent} />
        {event.is_online ? (
          <SectionUrl event={event} setEvent={setEvent} />
        ) : (
          <SectionPlaceDetail
            event={event}
            setEvent={setEvent}
            countriesPrefs={props.countriesPrefs}
          />
        )}
        <SectionNumOfPeopleForDetail event={event} setEvent={setEvent} />
      </div>

      {!event.semi_official_status ? (
        <SectionDateForDetail
          event={event}
          setEvent={setEvent}
          dateAlert={dateAlert}
          eventDateError={eventDateError}
          isDateChangeProhibitionDisplay={isDateChangeProhibitionDisplay}
          isEventEndDatetimeTouched={isEventEndDatetimeTouched}
          isApplicationDueDateTouched={isApplicationDueDateTouched}
          isMeetingDatetimeTouched={isMeetingDatetimeTouched}
          handleEventDateInput={handleEventDateInput}
        />
      ) : (
        ''
      )}
      {!event.semi_official_status ? (
        <SectionPublicity
          event={event}
          setEvent={setEvent}
          circle={props.circle}
        />
      ) : (
        ''
      )}
      <SectionStatus event={event} setEvent={setEvent} />

      <SectionCancelPolicy
        event={event}
        setEvent={setEvent}
        isNewPolicyApplicable={isNewPolicyApplicable}
        isNew={props.isNew}
      />

      <SectionAutoresponseMessage event={event} setEvent={setEvent} />

      <div style={{ paddingBottom: '12px' }}>
        <div className="container col-md-8 col-lg-6">
          <button
            type="button"
            className="w-100 a-button a-button__top a-button--orange mb-4 w-100"
            onClick={() => closeModal()}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

const SectionOnline = ({ event, setEvent }) => {
  return (
    <section>
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-0 d-inline-block text-left">
          リアル／オンライン
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 ">
          <div className="row justify-content-between p-3_5">
            <select
              id="is_online"
              onChange={(e) =>
                setEvent((prev) => ({
                  ...prev,
                  is_online: e.target.value === 'true',
                }))
              }
              defaultValue={event.is_online}
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
            >
              <option value={false}>リアル</option>
              <option value={true}>オンライン</option>
            </select>
          </div>
        </div>
      </div>
    </section>
  );
};

const SectionUrl = ({ event, setEvent }) => {
  return (
    <section id="url">
      <div className="bg-gray h-100 pt-3 pb-5">
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-0 d-inline-block">
            接続先URL
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              id="online_url"
              className={'p-1 w-100 form-control border'}
              defaultValue={event.online_url}
              onChange={(e) =>
                setEvent((prev) => ({
                  ...prev,
                  online_url: e.target.value,
                }))
              }
              placeholder=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const SectionPlaceDetail = ({ event, setEvent, countriesPrefs }) => {
  const handlePrefChange = React.useCallback(() => {
    const elements = document.getElementsByName('pref_id');
    let pref_id;
    for (let i = 0; i <= elements.length; i++) {
      if (elements[i].checked) {
        pref_id = Number(elements[i].value);
        break;
      }
    }
    setEvent((prev) => ({ ...prev, pref_id }));
  }, []);

  const handleMeetingPrefChange = React.useCallback(() => {
    const elements = document.getElementsByName('meeting_pref_id');
    let meeting_pref_id;
    for (let i = 0; i <= elements.length; i++) {
      if (elements[i].checked) {
        meeting_pref_id = elements[i].value;
        break;
      }
    }
    setEvent((prev) => ({ ...prev, meeting_pref_id }));
  }, []);

  return (
    <section id="place_detail">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          開催場所(目安)
        </p>
      </div>

      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5 border-bottom">
          <ul className="p-0 m-0">
            <FormPrefSelector
              countriesPrefs={countriesPrefs}
              handlePrefChange={() => handlePrefChange()}
              circle={event}
              name="pref_id"
            />
          </ul>
        </div>
      </div>

      <div className="shadow-sm mb-0 bg-white">
        <div className=" container col-md-8 col-lg-6 p-3_5 border-bottom">
          <p className="p-0 mb-2">開催場所(目安・場所など)</p>
          <input
            id="place"
            value={event.place || ''}
            onChange={(e) =>
              setEvent((prev) => ({ ...prev, place: e.target.value }))
            }
            className="p-0 w-100 textarea--eventreport"
            placeholder="目安の開催場所（例：飛田給駅）"
          />
        </div>
      </div>

      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          開催場所(詳細)
        </p>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div
          className=" container col-md-8 col-lg-6 p-3_5 justify-content-between border-bottom"
          style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <p className="p-0 mb-2">開催場所(詳細)</p>
          <input
            id="place_detail"
            value={event.place_detail || ''}
            onChange={(e) =>
              setEvent((prev) => ({
                ...prev,
                place_detail: e.target.value,
              }))
            }
            className="p-0 w-100 textarea--eventreport"
            placeholder="詳細な開催場所・住所（例：調布市西町376-3 味の素スタジアム 駅側入口）"
            style={{
              backgroundColor: '#FFFFFF',
            }}
          />
        </div>
      </div>

      <div
        className="shadow-sm mb-100 bg-white"
        style={{
          paddingBottom: '1%',
        }}
      >
        <div
          className=" container col-md-8 col-lg-6 p-3_5"
          style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <div className="row justify-content-center mt-3">
            <p className="p-0 mb-0" style={{ lineHeight: '32px' }}>
              参加者にしか表示しない
            </p>
            <input
              type="checkbox"
              id="is_display_place_detail"
              className="ml-3"
              checked={!event.is_display_place_detail}
              onChange={(e) =>
                setEvent((prev) => ({
                  ...prev,
                  is_display_place_detail: !e.target.checked,
                }))
              }
              style={{
                width: 20,
                height: 20,
                MozTransform: 'scale(1.4) translateY(5px)',
                WebkitTransform: 'scale(1.4) translateY(5px)',
                transform: 'scale(1.4) translateY(5px)',
              }}
            />
          </div>
        </div>
        <div className="w-100 h-25"> </div>
      </div>

      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          集合場所(目安)
        </p>
      </div>

      <div className="shadow-sm mb-2_5 bg-white">
        <div className="container col-md-8 col-lg-6 clearfix">
          <button
            className="a-button a-button__top a-button__top--outline mt-2 mb-0 float-left"
            type="button"
            onClick={() =>
              setEvent((prev) => ({
                ...prev,
                meeting_pref_id: event.pref_id,
                meeting_place: event.place,
                meeting_place_detail: event.place_detail,
              }))
            }
            style={{ height: '20px' }}
          >
            開催場所をコピー
          </button>
        </div>

        <div className=" container col-md-8 col-lg-6 p-3_5 border-bottom">
          <ul className="p-0 m-0">
            <FormPrefSelector
              countriesPrefs={countriesPrefs}
              handlePrefChange={() => handleMeetingPrefChange()}
              circle={event}
              name="meeting_pref_id"
            />
          </ul>
        </div>

        <div className=" container col-md-8 col-lg-6 p-3_5 border-bottom">
          <p className="p-0 mb-2">集合場所(目安・場所など)</p>
          <input
            id="meeting_place"
            value={event.meeting_place || ''}
            onChange={(e) =>
              setEvent((prev) => ({
                ...prev,
                meeting_place: e.target.value,
              }))
            }
            className="p-0 w-100 textarea--eventreport"
            placeholder="目安の集合場所（例：渋谷駅）"
          />
        </div>
      </div>

      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          集合場所(詳細)
        </p>
      </div>

      <div className="shadow-sm mb-2_5 bg-white">
        <div
          className=" container col-md-8 col-lg-6 p-3_5 border-bottom"
          style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <p className="p-0 mb-2">集合場所(詳細)</p>
          <input
            id="meeting_place_detail"
            value={event.meeting_place_detail || ''}
            onChange={(e) =>
              setEvent((prev) => ({
                ...prev,
                meeting_place_detail: e.target.value,
              }))
            }
            className="p-0 w-100 textarea--eventreport"
            placeholder="詳細な集合場所・住所（例：渋谷区渋谷1-1 ローソン渋谷店）"
            style={{
              backgroundColor: '#FFFFFF',
            }}
          />
        </div>

        <div
          className="shadow-sm mb-0 bg-white"
          style={{
            paddingBottom: '1%',
          }}
        >
          <div
            className=" container col-md-8 col-lg-6 p-3_5"
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '0 0 10px 10px',
            }}
          >
            <div className="row justify-content-center mt-3">
              <p className="p-0 mb-0" style={{ lineHeight: '32px' }}>
                参加者にしか表示しない
              </p>
              <input
                type="checkbox"
                id="is_display_meeting_place_detail"
                className="ml-3"
                checked={!event.is_display_meeting_place_detail}
                onChange={(e) =>
                  setEvent((prev) => ({
                    ...prev,
                    is_display_meeting_place_detail: !e.target.checked,
                  }))
                }
                style={{
                  width: 20,
                  height: 20,
                  MozTransform: 'scale(1.4) translateY(5px)',
                  WebkitTransform: 'scale(1.4) translateY(5px)',
                  transform: 'scale(1.4) translateY(5px)',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const SectionNumOfPeopleForDetail = ({ event, setEvent }) => {
  const numOfPeopleList = React.useMemo(() => {
    let num_of_people = [];
    for (let i = 2; i <= 100; i++) {
      num_of_people.push(i);
    }
    return num_of_people.map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  }, []);

  return (
    <section id="num_of_people_for_detail">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3 d-inline-block">
          イベント参加人数
        </p>
        <p className="text-fz-small text-black-50 mb-2">
          ※参加人数が最小人数に達しない場合は、イベントは開催されません。
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className=" container col-md-8 col-lg-6 ">
          <div className="row justify-content-between p-3_5 border-bottom">
            <p className="p-0 mb-0">最小人数</p>
            <select
              id="min_num_of_people"
              onChange={(e) => {
                const min_num_of_people = Number(e.target.value);
                setEvent((prev) => ({
                  ...prev,
                  min_num_of_people,
                }));
              }}
              defaultValue={event.min_num_of_people}
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
            >
              {numOfPeopleList}
            </select>
          </div>
          <div className="row justify-content-between p-3_5">
            <p className="p-0 mb-0">最大人数</p>
            <select
              id="capacity"
              onChange={(e) => {
                const capacity =
                  Number(e.target.value) === '' ? null : Number(e.target.value);
                setEvent((prev) => ({
                  ...prev,
                  capacity,
                }));
              }}
              defaultValue={event.capacity || ''}
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
            >
              <option value={''}>制限なし</option>
              {numOfPeopleList}
            </select>
          </div>
        </div>
      </div>
    </section>
  );
};

const SectionDateForDetail = ({
  event,
  setEvent,
  dateAlert,
  eventDateError,
  isDateChangeProhibitionDisplay,
  isEventEndDatetimeTouched,
  isApplicationDueDateTouched,
  isMeetingDatetimeTouched,
  handleEventDateInput,
}) => {
  React.useEffect(() => {
    if (window.innerWidth >= 768) {
      $('.datetimepicker').each(function () {
        $(this).datetimepicker({
          format: 'Y/m/d H:i',
          lang: 'ja',
          scrollInput: true,
          timepicker: true,
          step: 5,
        });
      });
    }
  }, []);

  let datetimeFormType;
  let datetimeFormat;
  if (window.innerWidth >= 768) {
    datetimeFormType = 'text';
    datetimeFormat = 'YYYY/MM/DD HH:mm';
    $('.datetimepicker').each(function () {
      $(this).datetimepicker({
        format: 'Y/m/d H:i',
        lang: 'ja',
        scrollInput: true,
        timepicker: true,
        step: 5,
      });
    });
  } else {
    datetimeFormType = 'datetime-local';
    datetimeFormat = 'YYYY-MM-DDTHH:mm';
  }

  return (
    <section id="date_for_detail">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3 d-inline-block">
          イベント日時
        </p>
        <p className="text-black-50 mb-3 mt-1" style={{ fontSize: '12px' }}>
          ※イベント日は10日以上先の日時にしましょう。参加者が集まるのに時間が掛かります。
        </p>
        {event.semi_official_status && event.is_new ? (
          <p className="text-danger text-fz-small mb-0">
            公認イベントは、3週間以上先の日付をご指定ください。
          </p>
        ) : (
          ''
        )}
        {isDateChangeProhibitionDisplay ? (
          <p className="text-danger text-fz-small mb-0">
            日付を変更することはできません。
          </p>
        ) : (
          ''
        )}
        {dateAlert ? (
          <p className="text-danger text-fz-small mb-0">{dateAlert}</p>
        ) : (
          ''
        )}
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 ">
          <label
            htmlFor="event-start-datetime-input-form"
            className="row justify-content-between p-3_5 border-bottom"
          >
            <p className="p-0 mb-0">開始</p>
            <input
              type={datetimeFormType}
              className="datetimepicker form-style-reset p-0 textarea--eventreport bg-gray"
              id="event-start-datetime-input-form"
              value={
                event.event_date
                  ? moment(event.event_date).format(datetimeFormat)
                  : ''
              }
              onChange={handleEventDateInput}
              onBlur={handleEventDateInput}
              placeholder="必須"
              autoComplete="off"
            />
          </label>
          <label
            htmlFor="event-end-datetime-input-form"
            className="row justify-content-between p-3_5 border-bottom"
          >
            <p className="pr-2 mb-0">終了</p>
            <input
              type={datetimeFormType}
              className="datetimepicker form-style-reset p-0 textarea--eventreport bg-gray"
              id="event-end-datetime-input-form"
              value={
                event.event_end_datetime
                  ? moment(event.event_end_datetime).format(datetimeFormat)
                  : ''
              }
              onChange={(e) => {
                isEventEndDatetimeTouched.current = true;
                setEvent((prev) => ({
                  ...prev,
                  event_end_datetime: e.target.value,
                }));
              }}
              onBlur={(e) => {
                isEventEndDatetimeTouched.current = true;
                setEvent((prev) => ({
                  ...prev,
                  event_end_datetime: e.target.value,
                }));
              }}
              placeholder="必須"
              autoComplete="off"
            />
          </label>
          <label
            htmlFor="event-meeting_datetime"
            className="row justify-content-between p-3_5 border-bottom"
          >
            <p className="pr-2 mb-0">集合</p>
            <input
              type={datetimeFormType}
              id="event-meeting_datetime"
              className="datetimepicker form-style-reset p-0 textarea--eventreport"
              value={
                event.meeting_datetime
                  ? moment(event.meeting_datetime).format(datetimeFormat)
                  : ''
              }
              onChange={(e) => {
                isMeetingDatetimeTouched.current = true;
                setEvent((prev) => ({
                  ...prev,
                  meeting_datetime: e.target.value,
                }));
              }}
              onBlur={(e) => {
                isMeetingDatetimeTouched.current = true;
                setEvent((prev) => ({
                  ...prev,
                  meeting_datetime: e.target.value,
                }));
              }}
              placeholder="2019/08/25 10:00"
              autoComplete="off"
            />
          </label>
          <label
            htmlFor="event-application_due_date"
            className={`row justify-content-between p-3_5 ${
              eventDateError ===
              '募集締め切りはイベント開始時刻より前に設定してください。'
                ? 'bg-light-pink'
                : ''
            }`}
          >
            <p className="pr-2 mb-0">申込締切</p>
            <input
              type={datetimeFormType}
              id="event-application_due_date"
              className="datetimepicker form-style-reset p-0 textarea--eventreport"
              value={
                event.application_due_date
                  ? moment(event.application_due_date).format(datetimeFormat)
                  : ''
              }
              onChange={(e) => {
                isApplicationDueDateTouched.current = true;
                setEvent((prev) => ({
                  ...prev,
                  application_due_date: e.target.value,
                }));
              }}
              onBlur={(e) => {
                isApplicationDueDateTouched.current = true;
                setEvent((prev) => ({
                  ...prev,
                  application_due_date: e.target.value,
                }));
              }}
              placeholder="2019/08/25 10:00"
              autoComplete="off"
            />
          </label>
          {eventDateError ===
            '募集締め切りはイベント開始時刻より前に設定してください。' && (
            <p className="text-danger text-fz-small mb-0 px-3_5 pb-2">
              {eventDateError}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

const SectionPublicity = ({ event, setEvent, circle }) => {
  return (
    <section id="publicity">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3">
          サークルメンバー以外に表示
        </p>
        <p className="text-fz-small text-black-20 mb-3">
          メンバー限定：サークルメンバーのみ閲覧可能
          <br />
          公開：サークルメンバー以外にも公開
        </p>
      </div>
      <div className="shadow-sm mb-4 bg-white">
        <div className=" container col-md-8 col-lg-6 p-3">
          <select
            id="is_publicity"
            className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
            defaultValue={event.is_publicity}
            onChange={(e) =>
              setEvent((prev) => ({
                ...prev,
                is_publicity: e.target.value,
              }))
            }
          >
            {circle.private_status === 0 ? (
              <option value={true}>公開</option>
            ) : (
              ''
            )}
            <option value={false}>メンバー限定</option>
          </select>
        </div>
      </div>
    </section>
  );
};

const SectionStatus = ({ event, setEvent }) => {
  return (
    <section id="status">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3">
          募集中ステータス
        </p>
      </div>
      <div className="shadow-sm mb-4 bg-white">
        <div className=" container col-md-8 col-lg-6 p-3">
          <select
            id="is_application_allowed"
            className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
            defaultValue={event.is_application_allowed}
            onChange={(e) =>
              setEvent((prev) => ({
                ...prev,
                is_application_allowed: e.target.value,
              }))
            }
          >
            <option value={true}>募集中</option>
            <option value={false}>募集停止</option>
          </select>
        </div>
      </div>
    </section>
  );
};

const EVENT_DATE_TO_AUTO_CANCELED_AT_DIFF_KEYS = [
  '2_hours_ago',
  '3_hours_ago',
  '6_hours_ago',
  '12_hours_ago',
  '24_hours_ago',
  '1_day_ago_23_59',
  '1_day_ago_21_00',
  '2_days_ago_23_59',
  '3_days_ago_23_59',
  '4_days_ago_23_59',
  '5_days_ago_23_59',
  '6_days_ago_23_59',
  '7_days_ago_23_59',
];

const EVENT_DATE_TO_AUTO_CANCELED_AT_DIFF_VALUES = {
  '2_hours_ago': 'イベント開始時刻の2時間前',
  '3_hours_ago': 'イベント開始時刻の3時間前',
  '6_hours_ago': 'イベント開始時刻の6時間前',
  '12_hours_ago': 'イベント開始時刻の12時間前',
  '24_hours_ago': 'イベント開始時刻の24時間前',
  '1_day_ago_23_59': 'イベント日の前日の23:59',
  '1_day_ago_21_00': 'イベント日の前日の21:00',
  '2_days_ago_23_59': 'イベント日の2日前の23:59',
  '3_days_ago_23_59': 'イベント日の3日前の23:59',
  '4_days_ago_23_59': 'イベント日の4日前の23:59',
  '5_days_ago_23_59': 'イベント日の5日前の23:59',
  '6_days_ago_23_59': 'イベント日の6日前の23:59',
  '7_days_ago_23_59': 'イベント日の7日前の23:59',
};

const SectionCancelPolicy = ({
  event,
  setEvent,
  isNewPolicyApplicable,
  isNew,
}) => {
  const CannotRefundDaysBeforeEventDateOptions = React.useMemo(() => {
    let options = [];
    options.push(
      <option value={-1} key={-1}>
        イベント開催日当日のキャンセルも返金可
      </option>,
    );
    const days = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25, 26, 27, 28,
    ];
    for (let i of days) {
      options.push(
        <option value={i} key={i}>
          イベント開催日{i == 0 ? '当日' : `${i}日前`}以降は返金不可
        </option>,
      );
    }
    return options;
  }, [event]);

  const FullRefundHoursAfterApplicationOptions = React.useMemo(() => {
    let options = [];
    const hours = isNewPolicyApplicable
      ? [1, 2, 3, 6]
      : [1, 2, 3, 6, 12, 24, 48, 72];
    for (let i of hours) {
      options.push(
        <option value={i} key={i}>
          申し込み後{i}時間以内までは全額返金
        </option>,
      );
    }
    return options;
  }, [event, isNewPolicyApplicable]);

  return (
    <section id="cancel_policy">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3 d-inline-block">
          キャンセルポリシー
        </p>
        {/* <p className="text-fz-small text-black-50 mb-2">
          ※参加者がキャンセルしたときに全額返金する条件を設定します。
        </p> */}
      </div>
      <div className="shadow-sm mb-0 bg-white mb-5 pb-3">
        <div className="container col-md-8 col-lg-6">
          <div className="p-3_5 border-bottom">
            <select
              id="cannot_refund_days_before_event_date"
              onChange={(e) => {
                const cannot_refund_days_before_event_date = Number.isNaN(
                  Number(e.target.value),
                )
                  ? null
                  : Number(e.target.value);
                setEvent((prev) => ({
                  ...prev,
                  cannot_refund_days_before_event_date,
                }));
              }}
              defaultValue={event.cannot_refund_days_before_event_date}
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              disabled={!isNew}
            >
              {CannotRefundDaysBeforeEventDateOptions}
            </select>
          </div>
          <div className="p-3_5 border-bottom">
            <select
              id="full_refund_hours_after_application"
              onChange={(e) => {
                const full_refund_hours_after_application = Number.isNaN(
                  Number(e.target.value),
                )
                  ? null
                  : Number(e.target.value);
                setEvent((prev) => ({
                  ...prev,
                  full_refund_hours_after_application,
                }));
              }}
              defaultValue={event.full_refund_hours_after_application}
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              disabled={!isNew}
            >
              {FullRefundHoursAfterApplicationOptions}
            </select>
            <div className="row justify-content-center mt-3">
              <p className="p-0 mb-0" style={{ lineHeight: '32px' }}>
                ただし、当日キャンセルは返金なし
              </p>
              <input
                type="checkbox"
                id="is_no_refund_on_the_day"
                className="ml-3"
                defaultChecked={event.is_no_refund_on_the_day}
                onChange={(e) =>
                  setEvent((prev) => ({
                    ...prev,
                    is_no_refund_on_the_day: e.target.checked,
                  }))
                }
                style={{
                  width: 20,
                  height: 20,
                  MozTransform: 'scale(1.4) translateY(5px)',
                  WebkitTransform: 'scale(1.4) translateY(5px)',
                  transform: 'scale(1.4) translateY(5px)',
                }}
                disabled={!isNew}
              />
            </div>
          </div>
          <div className="p-3_5 border-bottom">
            <select
              id="is_full_refund_until_min_num_of_people"
              onChange={(e) =>
                setEvent((prev) => ({
                  ...prev,
                  is_full_refund_until_min_num_of_people: e.target.value,
                }))
              }
              defaultValue={event.is_full_refund_until_min_num_of_people}
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              disabled={!isNew}
            >
              <option value={true}>
                最小人数未満のキャンセルの場合は全額返金
              </option>
              <option value={false}>
                最小人数未満のキャンセルでも返金無し
              </option>
            </select>
          </div>

          <div className="p-3_5">
            <p className="p-0 mb-0 mt-3" style={{ lineHeight: '32px' }}>
              最小人数未満の場合に自動中止を判断する時刻
              <br />
              ※参加者に事前決済金額が全額返金されます
            </p>
            <select
              id="event_date_to_auto_canceled_at_diff_key"
              onChange={(e) =>
                setEvent((prev) => ({
                  ...prev,
                  event_date_to_auto_canceled_at_diff_key: e.target.value,
                }))
              }
              value={
                event.event_date_to_auto_canceled_at_diff_key ||
                EVENT_DATE_TO_AUTO_CANCELED_AT_DIFF_KEYS[0]
              }
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
              disabled={!isNew}
            >
              {EVENT_DATE_TO_AUTO_CANCELED_AT_DIFF_KEYS.map((key) => (
                <option key={key} value={key}>
                  {EVENT_DATE_TO_AUTO_CANCELED_AT_DIFF_VALUES[key]}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </section>
  );
};

const SectionAutoresponseMessage = ({ event, setEvent }) => {
  return (
    <section id="autoresponse_message">
      <div className="bg-gray h-100 pt-3 pb-5">
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-0 d-inline-block">
            自動送信テキスト
          </p>
          <p className="text-fz-small text-black-50 mb-2">
            イベント参加申し込み後に参加者へ自動送信されます。
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <textarea
              id="autoresponse_message"
              className={'p-1 w-100 form-control border'}
              value={event.autoresponse_message}
              onChange={(e) =>
                setEvent((prev) => ({
                  ...prev,
                  autoresponse_message: e.target.value,
                }))
              }
              placeholder=""
              rows={7}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionDetail;
